<template>
    <v-btn depressed @click="$router.go(-1)">Go Back</v-btn>
</template>

<script>
export default {
  name: "GoBackBtn",

  methods: {    
  }
};
</script>
